import { render, staticRenderFns } from "./SideBarPanel.vue?vue&type=template&id=1d87fed8&scoped=true&"
import script from "./SideBarPanel.vue?vue&type=script&lang=js&"
export * from "./SideBarPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d87fed8",
  null
  
)

export default component.exports